import React, { useRef, useState, useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';

const PORTAL_ROOT_ID = 'portal-root';

const PortalComponent = ({ children, rootId = PORTAL_ROOT_ID, }) => {
    const rootRef = useRef(null);
    const [mounted, setMounted] = useState(false);
    useLayoutEffect(() => {
        rootRef.current = document.createElement('div');
        rootRef.current.setAttribute('data-react-portal', 'true');
        rootRef.current.setAttribute('id', rootId);
        document.body.appendChild(rootRef.current);
        setMounted(true);
        return () => {
            var _a;
            (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.remove();
        };
    }, []);
    if (!mounted || !rootRef.current) {
        return null;
    }
    return React.createElement(React.Fragment, null, createPortal(children, rootRef.current));
};

export { PortalComponent };
